/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RegenerateLetterOption/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function RegenerateLetterOption({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Edit/Actions/Content/RegenerateLetterOption"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 marginTop={dtSpaceXxxs}
 marginBottom={1}
 cursor="pointer"
 alignItems="center"
 width="100%"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../RegenerateLetterModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../RegenerateLetterModal/Content'))}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 text="Regenerate letter"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}